import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoIt: CultureInfo = {
  name: 'it',
  displayName: 'Italian',
  iso3LanguageCode: 'ita',
  iso2LanguageCode: 'it',
  ietfLanguageTag: 'it',
  parent: null
};
